import { render, staticRenderFns } from "./BlogView.vue?vue&type=template&id=abaeed22&"
import script from "./BlogView.vue?vue&type=script&lang=js&"
export * from "./BlogView.vue?vue&type=script&lang=js&"
import style0 from "./BlogView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
